module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/high-capacity-transport-reward-50.e8a910f6.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/high-capacity-transport-reward-50.png
// module id = 3785
// module chunks = 11